export default {
    database: {
        BasicInfo: 'Basic Info',
        DatabaseType: 'Driver',
        RemoteDatabase: 'Remote',
        BuiltInDatabase: 'Built-in',
        DatabaseName: 'Name',
        DatabaseTypeTitle: 'Type',
        DatabaseNameTitle: 'Name',
        DatabaseDescription: 'Description',
        DatabaseDescriptionTitle: 'Description',
        PermissionManagement: 'Permission',
        PermissionSettings: 'Operations',
        Query: 'Query',
        Add: 'Add',
        Edit: 'Edit',
        Delete: 'Delete',
        ConnectionInfo: 'Connection',
        Port: 'Port',

        DatabaseNameLabel: 'Name',

        DeleteDatabase: 'Delete Database',
        ConfirmDelete: 'Delete will not be able to recover this database, are you sure to delete?',
        DeleteSuccess: 'Delete successful',
        ModifySuccess: 'Modification successful',
        DatabaseTypeLabel: 'Database Type',
        Host: 'Host',

        Username: 'User',
        DatabaseLabel: 'Database',
        DeletingDatabase: 'Deleting database, please wait...',
        PleaseEnterDatabaseName: 'Enter database name',
        PleaseEnterDatabaseDescription: 'Enter database description',
        PleaseEnterDatabase: 'Please enter database',
        PleaseEnterHost: 'Please enter host',
        PleaseEnterPort: 'Please enter port',
        PleaseEnterUsername: 'Please enter username',
        PleaseEnterPassword: 'Please enter password',
        PleaseSelectDatabaseType: 'Please select database type',
        PleaseSelectPermission: 'Please select at least one permission',
        ModifyingDatabase: 'Modifying database...',
        ModifyDatabaseInfo: 'Modify Database Information',
        DatabaseNameRequired: 'Database name is required',
        DatabaseDescriptionTip: 'The database description will be used for database decisions, please describe the database content and usage scenarios as clearly as possible',
        PermissionSettingsTip: 'Database operations that can be performed through dialogue',
        Cancel: 'Cancel',
        Confirm: 'Confirm',
        Number: 'Number',
        Decimal: 'Decimal',
        Text: 'Text',
        Datetime: 'Datetime',
        Longtext: 'Long text',

        DeleteConfirm: 'After deletion, the data cannot be recovered. Are you sure you want to delete?',
        DeleteFile: 'Delete Data',
        Operation: 'Operations',
        OneClickImport: 'One-click Import',
        ImportTable: 'Import Table',
        ImportTableTip: 'Upload excel or csv files. The column names in the table need to match the database field names.',
        DownloadTemplate: 'Download Template',
        ReUpload: 'Re-upload',
        UploadTip: 'Drag and drop file or click to upload',
        FileImporting: 'File is being imported, please wait patiently~',
        PleaseUploadFile: 'Please upload the file first',
        ImportFailed: 'Import failed',
        ImportFailedFiveRecords: ' Failed to import {count} records.',
        ImportSuccess: 'Import successful {count} records',
        PleaseCreateDataTable: 'Please create a data table first',
        ConfigureDataTable: 'Configure Data Table',
        RemoteDatabaseTip: 'Remote connection to your own database, one-click synchronization of database tables and fields, real-time retrieval of the latest data.',
        PleaseContactCustomerService: {
            please: 'Please',
            contactCustomerService: 'contact customer service',
            toActivate: 'to activate the usage rights',
        },
        PleaseDescribeYourDatabaseUsageScenario: 'Please describe your database usage scenario in detail',
        SelectAll: 'Select All',
        NoData: 'No data',
        NextStep: 'Next Step',
        PleaseSelectAtLeastOnePermission: 'Please select at least one permission',
        CreateSuccess: 'Create successful, you can click "One-click Import" to initialize data, or select "Data Table Configuration" to manually create a table',
        CreateDatabase: 'Create database',
        DataPreview: 'Data',
        TableConfig: 'Tables',
        DatabaseConfig: 'Settings',
        DataTables: 'Tables',
        Create: 'Create',
        FieldConfig: 'Table Fields',
        AddTableField: 'Add Table Field',
        DeleteTable: 'Delete Data Table',
        FieldName: 'Name',
        PleaseEnterFieldName: 'Enter field name',
        FieldType: 'Type',
        FieldDescription: 'Description',
        FieldDescriptionTip: 'The field description will be used for SQL statement generation, please describe the field as clearly as possible',
        PleaseEnterFieldDescription: 'Enter field description',
        AddRemoteTable: 'Add Remote Table',
        AddTable: 'Add Table',
        TableImport: 'Table Import',
        TableName: 'Table Name',
        PleaseEnterTableName: 'Enter table name',
        TableDescription: 'Table Description',
        TableDescriptionTip: 'The table description will be used for SQL statement generation, please describe the table as clearly as possible',
        PleaseEnterTableDescription: 'Enter table description',
        CurrentFile: 'Current File',
        fileType: {
            Integer: 'Integer',
            Decimal: 'Decimal',
            Text: 'Text',
            Datetime: 'Datetime',
            Longtext: 'Longtext',
            LongtextTip: 'Text longer than 1000 characters',
        },
        EditTableInfo: 'Edit Table Info',
        TableImportTip: 'Upload EXCEL or CSV files, automatically create table structures and import data',
        FieldNameLabel: 'Field Name ',
        FieldTypeLabel: 'Field Type ',
        FieldDescriptionLabel: 'Field Description ',
        SelectFieldType: 'Select Field Type',
        PrimaryKeyID: 'Primary Key ID',
        DeleteTableConfirm: 'Deleting will not be able to recover this data table, are you sure to delete?',

        DeleteTableLoading: 'Data table deletion, please wait~',
        DeleteTableFieldLoading: 'Data table field deletion, please wait~',
        DeleteTableFieldConfirm: 'Deleting will not be able to recover this data table field, are you sure to delete?',
        DeleteTableField: 'Delete Data Table Field',
        AddSuccess: 'Add successful',
        UploadFailed: 'Upload failed',
        BuiltInDatabaseTip: 'Directly create a database, customize the table structure and fields, and add data through import or manual addition.',
    }
}